import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, Table, Message } from 'rsuite'
import CustomAlertMessageInfo from '../../CustomAlertMessageInfo'
import InputForm from '../../../components/forms/input/InputForm'
import EditButton from '../../../components/buttons/editButton/EditButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { cloneDeep, isEmpty } from 'lodash-es'
import CKEditorFrom from '../../../components/forms/input/CKEditorFrom'
import HTMLWidget from '../../HTMLWidget'
import { budgetFormat } from '../../../utils/formatterUtil'

export default function ActivitieBudgetWidget({
  //schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  loading,
  noteForm,
  header,
  button,
  budgetNote,
  budgetDataName = 'budgetDataName',
  isView,
  dataList = [],
  setLoading = () => {},
  onDelete = () => {},
  onSave = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table

  // const [schema, setSchema] = useState(_schema)
  const [datas, setDatas] = useState(dataList)
  const [countIndex, setCountIndex] = useState(0)
  const [mapDatas, setMapDatas] = useState(new Map())

  useEffect(() => {
    setDatas(dataList || [])

    var map = new Map()
    dataList?.forEach((item) => {
      map.set(item.id, item)
    })

    setMapDatas(map)
    setValue(budgetDataName, map)
  }, [])

  const handleAdd = () => {
    // let newId = 'NEW_' + datas.length
    let data = cloneDeep(datas)
    let map = cloneDeep(mapDatas)

    let item = {
      id: `NEW_${countIndex}`,
      detail: '',
      quantity: 0,
      price: 0,
    }

    data.push(item)
    map.set(item.id, item)

    setDatas(data)
    setMapDatas(map)

    setCountIndex(countIndex + 1)
  }

  const handleDelete = (rowData, index) => {
    let data = cloneDeep(datas)
    let map = cloneDeep(mapDatas)

    data.splice(index, 1)
    map.delete(rowData.id)

    setDatas(data)

    setValue(budgetDataName, map)
  }

  return (
    <Panel
      style={props.style || { marginTop: 20 }}
      header={header || 'งบประมาณ'}
      collapsible //={props.collapsible}
      defaultExpanded //={props.defaultExpanded}
      bordered //={props.bordered}
    >
      <Row style={{ marginTop: -10 }}>
        <Table
          rowKey="id"
          autoHeight
          wordWrap={true}
          data={datas}
          loading={loading}
          headerHeight={70}
        >
          <Column width={100} align="center">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>
          <Column minWidth={200} flexGrow={1}>
            <HeaderCell>รายการ</HeaderCell>
            <Cell>
              {(rowData, index) => {
                return (
                  <>
                    {isView ? (
                      <>{rowData.detail}</>
                    ) : (
                      <>
                        <InputForm
                          hideLabel
                          errorPopUp
                          name={`${rowData.id}:detail`}
                          schema={{
                            //name: 'detail',
                            disabled: false,
                            //value: mapDatas?.get(rowData.id)?.detail,
                            validators: [
                              {
                                type: 'REQUIRED',
                                value: null,
                                errorMessage: 'กรุณาระบุรายการ',
                              },
                            ],
                          }}
                          value={mapDatas?.get(rowData.id)?.detail}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          onChange={(value) => {
                            let map = cloneDeep(mapDatas)

                            map.get(rowData.id).detail = value

                            setMapDatas(map)

                            setValue(budgetDataName, map)
                          }}
                        />
                      </>
                    )}
                  </>
                )
              }}
            </Cell>
          </Column>
          {/* <Column width={140} align="center">
            <HeaderCell>จำนวนครั้งที่จัดกิจกรรม</HeaderCell>
            <Cell>
              {(rowData, index) => {
                return (
                  <>
                    {isView ? (
                      <>{rowData.numberOfTimes}</>
                    ) : (
                      <>
                        <InputForm
                          hideLabel
                          errorPopUp
                          isInputNumber
                          name={`${rowData.id}:numberOfTimes`}
                          schema={{
                            disabled: false,
                            validators: [
                              // {
                              //   type: 'REQUIRED',
                              //   value: null,
                              //   errorMessage: 'กรุณาระบุจำนวนครั้งที่จัดกิจกรรม',
                              // },
                            ],
                          }}
                          value={mapDatas?.get(rowData.id)?.numberOfTimes}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          onChange={(value) => {
                            let map = cloneDeep(mapDatas)

                            map.get(rowData.id).numberOfTimes = value

                            setMapDatas(map)

                            setValue(budgetDataName, map)
                          }}
                        />
                      </>
                    )}
                  </>
                )
              }}
            </Cell>
          </Column> */}
          <Column width={120} align="right">
            <HeaderCell>จำนวน</HeaderCell>
            <Cell>
              {(rowData, index) => {
                return (
                  <>
                    {isView ? (
                      <>{rowData.quantity}</>
                    ) : (
                      <>
                        <InputForm
                          hideLabel
                          errorPopUp
                          isInputNumber
                          name={`${rowData.id}:quantity`}
                          schema={{
                            disabled: false,
                            validators: [
                              {
                                type: 'REQUIRED',
                                value: null,
                                errorMessage: 'กรุณาระบุจำนวน',
                              },
                            ],
                          }}
                          value={mapDatas?.get(rowData.id)?.quantity}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          onChange={(value) => {
                            let map = cloneDeep(mapDatas)

                            map.get(rowData.id).quantity = value

                            setMapDatas(map)

                            setValue(budgetDataName, map)
                          }}
                        />
                      </>
                    )}
                  </>
                )
              }}
            </Cell>
          </Column>
          <Column width={120} align="center">
            <HeaderCell>หน่วย</HeaderCell>
            <Cell>
              {(rowData, index) => {
                return (
                  <>
                    {isView ? (
                      <>{rowData.unit}</>
                    ) : (
                      <>
                        <InputForm
                          hideLabel
                          errorPopUp
                          name={`${rowData.id}:unit`}
                          schema={{
                            disabled: false,
                            validators: [],
                          }}
                          value={mapDatas?.get(rowData.id)?.unit}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          onChange={(value) => {
                            let map = cloneDeep(mapDatas)

                            map.get(rowData.id).unit = value

                            setMapDatas(map)

                            setValue(budgetDataName, map)
                          }}
                        />
                      </>
                    )}
                  </>
                )
              }}
            </Cell>
          </Column>
          <Column width={140} align="right">
            <HeaderCell>ราคา (บาท)</HeaderCell>
            <Cell>
              {(rowData, index) => {
                return (
                  <>
                    {isView ? (
                      <>{budgetFormat(rowData.price)}</>
                    ) : (
                      <>
                        <InputForm
                          hideLabel
                          errorPopUp
                          isInputNumber
                          name={`${rowData.id}:price`}
                          schema={{
                            //name: 'detail',
                            disabled: false,
                            //value: mapDatas?.get(rowData.id)?.price,
                            validators: [
                              {
                                type: 'REQUIRED',
                                value: null,
                                errorMessage: 'กรุณาระบุราคา',
                              },
                            ],
                          }}
                          value={mapDatas?.get(rowData.id)?.price}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          onChange={(value) => {
                            let map = cloneDeep(mapDatas)

                            map.get(rowData.id).price = value

                            setMapDatas(map)

                            setValue(budgetDataName, map)
                          }}
                        />
                      </>
                    )}
                  </>
                )
              }}
            </Cell>
          </Column>
          <Column width={140} align="right">
            <HeaderCell>รวม (บาท)</HeaderCell>
            <Cell>
              {(rowData, index) => {
                var total = budgetFormat(
                  (mapDatas?.get(rowData.id)?.quantity || 0) *
                    (mapDatas?.get(rowData.id)?.price || 0)
                )
                return <>{isView ? <>{total}</> : <div style={{ marginTop: 10 }}>{total}</div>}</>
              }}
            </Cell>
          </Column>
          {!isView && (
            <Column width={100} align="center" fixed="right">
              <HeaderCell>จัดการ</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  return (
                    <>
                      <CancelButton
                        icon="trash-o"
                        children="ลบ"
                        onClick={() => {
                          handleDelete(rowData, index)
                        }}
                      />
                    </>
                  )
                }}
              </Cell>
            </Column>
          )}
        </Table>

        {noteForm ? (
          <div style={{ marginTop: 20 }}>
            <CKEditorFrom
              schema={noteForm}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              value={budgetNote}
            />
          </div>
        ) : (
          <>
            {!isView && (
              <Row style={{ textAlign: 'right' }}>
                <SaveButton
                  style={{
                    marginTop: 10,
                    marginRight: 10,
                  }}
                  icon="plus"
                  children={`เพิ่ม${header || ''}`}
                  onClick={handleAdd}
                />
              </Row>
            )}
            {budgetNote && (
              <Message
                showIcon
                type={'info'}
                description={<HTMLWidget data={budgetNote} />}
                onClose={() => setNotiMsg('')}
                style={{ marginBottom: 10, marginTop: 10 }}
              />
            )}
          </>
        )}
      </Row>

      <Controller
        key={budgetDataName}
        name={budgetDataName}
        control={control}
        defaultValue={mapDatas}
        values={mapDatas}
      />
      {button ? <>{button}</> : ''}
    </Panel>
  )
}
